import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVesselSemiTubeHeatingCoolingCoil = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 110,
	height: 70,
	viewBox: "0 0 110.0 70.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 0,
		width: 100,
		height: 70,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 5.0 20.0 A 5.0 5.0 0.0 1 0 5.0 30.0 Z M 5.0 50.0 A 5.0 5.0 0.0 1 0 5.0 60.0 Z M 105.0 10.0 A 5.0 5.0 0.0 1 1 105.0 20.0 Z M 105.0 40.0 A 5.0 5.0 0.0 1 1 105.0 50.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgVesselSemiTubeHeatingCoolingCoil;
